import styled from '@emotion/styled';
import { TabletWidth } from '../../../global.style';
import { getColor } from '../../common/UICommon';

export const EnterEmailV3Screen = styled.div<{ imgDesktop: string; imgMobile: string }>`
  background-image: url(${({ imgDesktop }) => imgDesktop});
  background-size: cover;
  background-position: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${TabletWidth}px) {
    background-image: url(${({ imgMobile }) => imgMobile});
    background-position: top;
    align-items: start;
  }
`;

export const EnterEmailV3ScreenContent = styled.div`
  position: absolute;
  max-width: 327px;
  text-align: left;

  @media (max-width: ${TabletWidth}px) {
    margin-top: 92px;
  }
`;

export const EnterEmailV3LogoWrapper = styled.div`
  display: none;

  @media (max-width: ${TabletWidth}px) {
    display: block;
    position: absolute;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const EnterEmailV3StepTitle = styled.h6`
  font-family: Lora;
  font-size: 28px;
  font-weight: 600;
  line-height: 32px;
  margin-bottom: 32px;
  color: ${getColor('BLACK')};

  @media (max-width: ${TabletWidth}px) {
    font-size: 24px;
    line-height: 30px;
  }
`;

export const EnterEmailV3StepAgreement = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin-top: 16px;
  margin-bottom: 52px;

  color: ${getColor('BLACK_60')};
`;

export const EnterEmailV3CtaWrapper = styled.div`
  width: 100%;
  @media (max-width: ${TabletWidth}px) {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 16px 24px;
  }
`;
